export const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
};

export const formatarDataComHora = (data: string): string => {
    // Se a data não tem hora, cria com horário local atual
    if (!data.includes('T')) {
        const hoje = new Date();
        const horas = String(hoje.getHours()).padStart(2, '0');
        const minutos = String(hoje.getMinutes()).padStart(2, '0');
        const segundos = String(hoje.getSeconds()).padStart(2, '0');
        
        return `${data}T${horas}:${minutos}:${segundos}`;
    }
    
    // Se já tem hora, formata normalmente (como antes)
    const dataObj = new Date(data);
    const horas = String(dataObj.getHours()).padStart(2, '0');
    const minutos = String(dataObj.getMinutes()).padStart(2, '0');
    const segundos = String(dataObj.getSeconds()).padStart(2, '0');

    return `${data.split('T')[0]}T${horas}:${minutos}:${segundos}`;
};